<template>
  <div class="row ml-0 mr-0 poster mb-3 pt-1 pb-1 alert-primary">
    <div v-bind:id="'poster' + poster.abstract_id" class="col col-4 d-flex my-auto" v-if="thumbnails === true">
      <router-link :to="'/viewer/' + poster.abstract_id">
        <img v-lazy="getImgUrl(poster.content.poster)" v-bind:alt="poster.title"
             class="img-fluid align-middle">
      </router-link>
    </div>
    <div class="col poster-text d-flex flex-column  pt-1 pb-1">
      <div>{{ _.groupCapital }}: {{ poster.session }}</div>
      <router-link :to="'/viewer/' + poster.abstract_id" class="align-middle mt-2 font-weight-bold"
                   v-html="poster.presentation_code +' ' + poster.title"></router-link>
      <div class="align-middle smaller mt-2" v-html="poster.authorline"></div>
      <div class="align-middle smaller mb-2 font-italic" v-html="poster.instituteline"></div>
      <div class="mt-auto">
        <UserShare :poster="poster.abstract_id" :title="poster.title" v-if="shareShow == poster.abstract_id"
                   class="mb-1"/>
        <router-link class="btn btn-primary btn-sm" :to="'/viewer/' + poster.abstract_id">
          <icon :icon="['fad', 'eye']"/>
          View
        </router-link>
        <router-link v-if="poster.content.audio != null" class="btn btn-link btn-sm ml-2"
                     :to="'/viewer/' + poster.abstract_id">
          <icon :icon="['fad', 'volume']"/> Audio
        </router-link>
        <router-link class="btn btn-primary btn-sm ml-2" :to="'/viewer/video/' + poster.abstract_id"
                     v-if="poster.content.video != null">
          <icon :icon="['fad', 'video']"/>
          Video
        </router-link>
<!--        <button class="btn btn-primary btn-sm ml-2" v-on:click="toggleShare(poster.abstract_id)">-->
<!--          <icon :icon="['fad', 'share']"/>-->
<!--          Share-->
<!--        </button>-->
        <router-link class="btn btn-primary btn-sm ml-2" :to="'/mail/' + poster.abstract_id">
          <icon :icon="['fad', 'envelope']"/>
          Contact
        </router-link>
        <div class="float-right font-weight-bold">
          Rating: {{ ratings[poster.id].rating }} ({{ ratings[poster.id].count }} votes)
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Rating from "../Rating"
import UserShare from "../UserShare"
import {mapState} from 'vuex'

export default {
  name: 'Wall',
  components: {Rating, UserShare},
  props: {
    poster: {},
    shareShow: {},
  },
  computed: {
    ...mapState(
        ['ratings', "thumbnails"]
    ),
  },
  methods: {
    getImgUrl(src) {
      // return process.env.VUE_APP_PATH_FILESERVERURL + src + '/resize/' + process.env.VUE_APP_THUMBNAIL_WIDTH + '/' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
      return process.env.VUE_APP_PATH_S3URL + src + '-' + process.env.VUE_APP_THUMBNAIL_WIDTH + '-' + process.env.VUE_APP_THUMBNAIL_HEIGHT + '-1-undefined-image';
    },
    toggleShare: function (poster) {
      if (this.shareShow != poster) {
        this.shareShow = poster;
      } else {
        this.shareShow = null;
      }
    },
  },
}
</script>
<style scoped>
.poster {
  /*border-bottom: solid 2px #7e7e7e;*/
}

.poster-text {
}

</style>
